import { render, staticRenderFns } from "./CustomerGroupFilter.vue?vue&type=template&id=01caef6a&"
import script from "./CustomerGroupFilter.vue?vue&type=script&lang=js&"
export * from "./CustomerGroupFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports